(() => {

  if (window.RTGSavedGems && window.RTGSavedGems.__initialized) return;

  const FAVOURITES_KEY = 'rtg_favourites_v1';

  const COMPARE_KEY = 'rtg_compare_v1';

  const CUSTOMER_KEY = 'rtg_saved_customer_v1';

  const FAVOURITES_DIRTY_KEY = 'rtg_favourites_dirty_v1';

  const COMPARE_DIRTY_KEY = 'rtg_compare_dirty_v1';

  const ACCOUNT_API = 'https://my.roughtogems.com/api/saved-gems';

  const MAX_COMPARE = 8;

  const memoryFallback = {

    [FAVOURITES_KEY]: [],

    [COMPARE_KEY]: []

  };

  let accountState = 'unknown';

  let accountSyncPromise = null;

  const saveChains = {

    favourites: Promise.resolve(),

    compare: Promise.resolve()

  };

  function safeParse(value) {

    try {

      const parsed = JSON.parse(value);

      return Array.isArray(parsed) ? parsed : [];

    } catch (_) {

      return [];

    }

  }

  function read(key) {

    try {

      return safeParse(window.localStorage.getItem(key) || '[]');

    } catch (_) {

      return memoryFallback[key].slice();

    }

  }

  function write(key, list) {

    try {

      window.localStorage.setItem(key, JSON.stringify(list));

    } catch (_) {

      memoryFallback[key] = list.slice();

    }

  }

  function readText(key) {

    try {

      return String(window.localStorage.getItem(key) || '');

    } catch (_) {

      return '';

    }

  }

  function writeText(key, value) {

    try {

      window.localStorage.setItem(key, String(value));

    } catch (_) {

      // No-op if localStorage is unavailable.

    }

  }

  function removeText(key) {

    try {

      window.localStorage.removeItem(key);

    } catch (_) {

      // No-op if localStorage is unavailable.

    }

  }

  function isDirty(key) {

    return readText(key) === '1';

  }

  function setDirty(key, dirty) {

    if (dirty) {

      writeText(key, '1');

    } else {

      removeText(key);

    }

  }

  function normaliseItem(item) {

    if (!item || typeof item !== 'object') return null;

    const handle = String(item.handle || '');

    if (!handle) return null;

    return {

      id: String(item.id || ''),

      handle,

      url: String(item.url || ''),

      title: String(item.title || ''),

      price: String(item.price || ''),

      image: String(item.image || ''),

      available:

        typeof item.available === 'boolean'

          ? item.available

          : String(item.available ?? 'true') === 'true'

    };

  }

  function normaliseList(list) {

    if (!Array.isArray(list)) return [];

    const seen = new Set();

    const result = [];

    list.forEach(item => {

      const normalised = normaliseItem(item);

      if (!normalised || seen.has(normalised.handle)) return;

      seen.add(normalised.handle);

      result.push(normalised);

    });

    return result;

  }

  function mergeLists(primary, secondary, limit = Infinity) {

    const merged = [];

    const seen = new Set();

    [primary, secondary].forEach(list => {

      normaliseList(list).forEach(item => {

        if (seen.has(item.handle) || merged.length >= limit) return;

        seen.add(item.handle);

        merged.push(item);

      });

    });

    return merged;

  }

  function sameHandles(a, b) {

    const left = normaliseList(a).map(item => item.handle);

    const right = normaliseList(b).map(item => item.handle);

    return (

      left.length === right.length &&

      left.every((handle, index) => handle === right[index])

    );

  }

  function normaliseProduct(button) {

    return {

      id: String(button.dataset.productId || ''),

      handle: String(button.dataset.productHandle || ''),

      url: String(button.dataset.productUrl || ''),

      title: String(button.dataset.productTitle || ''),

      price: String(button.dataset.productPrice || ''),

      image: String(button.dataset.productImage || ''),

      available: String(button.dataset.productAvailable || 'true') === 'true'

    };

  }

  function findIndex(list, handle) {

    return list.findIndex(item => item && item.handle === handle);

  }

  function has(key, handle) {

    return findIndex(read(key), handle) !== -1;

  }

  function syncHeaderCounts() {

    const favourites = read(FAVOURITES_KEY);

    const compare = read(COMPARE_KEY);

    document

      .querySelectorAll('[data-rtg-favourite-count]')

      .forEach(counter => {

        counter.textContent = String(favourites.length);

        counter.hidden = favourites.length === 0;

      });

    document

      .querySelectorAll('[data-rtg-compare-count]')

      .forEach(counter => {

        counter.textContent = String(compare.length);

        counter.hidden = compare.length === 0;

      });

  }

  function emitUpdate() {

    const favourites = read(FAVOURITES_KEY);

    const compare = read(COMPARE_KEY);

    const detail = {

      favourites,

      compare,

      favouriteCount: favourites.length,

      compareCount: compare.length,

      maxCompare: MAX_COMPARE

    };

    syncHeaderCounts();

    document.dispatchEvent(

      new CustomEvent('rtg:saved-gems-updated', {detail})

    );

  }

  function ensureToast() {

    let toast = document.querySelector('[data-rtg-saved-toast]');

    if (toast) return toast;

    toast = document.createElement('div');

    toast.setAttribute('data-rtg-saved-toast', '');

    toast.setAttribute('role', 'status');

    toast.setAttribute('aria-live', 'polite');

    Object.assign(toast.style, {

      position: 'fixed',

      left: '50%',

      bottom: '24px',

      zIndex: '99999',

      maxWidth: 'calc(100vw - 32px)',

      padding: '11px 15px',

      border: '1px solid rgba(18,18,16,.18)',

      borderRadius: '8px',

      background: '#121210',

      color: '#fff',

      fontFamily: 'Arial, Helvetica, sans-serif',

      fontSize: '12px',

      lineHeight: '1.35',

      letterSpacing: '.02em',

      boxShadow: '0 8px 28px rgba(0,0,0,.18)',

      opacity: '0',

      transform: 'translate(-50%, 8px)',

      pointerEvents: 'none',

      transition: 'opacity .18s ease, transform .18s ease'

    });

    document.body.appendChild(toast);

    return toast;

  }

  let toastTimer = null;

  function showToast(message) {

    const toast = ensureToast();

    toast.textContent = message;

    toast.style.opacity = '1';

    toast.style.transform = 'translate(-50%, 0)';

    window.clearTimeout(toastTimer);

    toastTimer = window.setTimeout(() => {

      toast.style.opacity = '0';

      toast.style.transform = 'translate(-50%, 8px)';

    }, 2200);

  }

  function setButtonState(button, active) {

    if (!button) return;

    button.classList.toggle('is-active', active);

    button.setAttribute('aria-pressed', active ? 'true' : 'false');

    const title = button.dataset.productTitle || 'this gemstone';

    if (button.matches('[data-rtg-favourite]')) {

      button.setAttribute(

        'aria-label',

        active

          ? `Remove ${title} from favourites`

          : `Add ${title} to favourites`

      );

      button.title = active ? 'Remove favourite' : 'Favourite';

    }

    if (button.matches('[data-rtg-compare]')) {

      button.setAttribute(

        'aria-label',

        active

          ? `Remove ${title} from compare`

          : `Add ${title} to compare`

      );

      button.title = active ? 'Remove from compare' : 'Compare';

    }

  }

  function syncButtons(root = document) {

    root.querySelectorAll('[data-rtg-favourite]').forEach(button => {

      setButtonState(

        button,

        has(FAVOURITES_KEY, button.dataset.productHandle || '')

      );

    });

    root.querySelectorAll('[data-rtg-compare]').forEach(button => {

      setButtonState(

        button,

        has(COMPARE_KEY, button.dataset.productHandle || '')

      );

    });

  }

  async function fetchAccountState() {

    const response = await fetch(ACCOUNT_API, {

      method: 'GET',

      credentials: 'include',

      mode: 'cors',

      cache: 'no-store'

    });

    if (!response.ok) {

      throw new Error(`Saved gems account request failed (${response.status})`);

    }

    return response.json();

  }

  async function postAccountList(kind, list) {

    const formData = new FormData();

    formData.set('kind', kind);

    formData.set('items', JSON.stringify(normaliseList(list)));

    const response = await fetch(ACCOUNT_API, {

      method: 'POST',

      credentials: 'include',

      mode: 'cors',

      cache: 'no-store',

      body: formData

    });

    let payload = null;

    try {

      payload = await response.json();

    } catch (_) {

      payload = null;

    }

    if (response.status === 401 || payload?.loggedIn === false) {

      accountState = 'logged-out';

      return {ok: false, loggedIn: false};

    }

    if (!response.ok || !payload?.ok) {

      throw new Error(payload?.error || `Saved gems sync failed (${response.status})`);

    }

    accountState = 'logged-in';

    return payload;

  }

  function queueAccountSave(kind, list) {

    const key =

      kind === 'favourites'

        ? FAVOURITES_DIRTY_KEY

        : COMPARE_DIRTY_KEY;

    const snapshot =

      kind === 'compare'

        ? normaliseList(list).slice(0, MAX_COMPARE)

        : normaliseList(list);

    setDirty(key, true);

    saveChains[kind] = saveChains[kind]

      .catch(() => undefined)

      .then(async () => {

        if (accountState === 'unknown') {

          await syncFromAccount();

        }

        if (accountState !== 'logged-in') {

          setDirty(key, false);

          return;

        }

        try {

          const result = await postAccountList(kind, snapshot);

          if (result?.ok) {

            setDirty(key, false);

          }

        } catch (error) {

          console.warn('[RTG Saved Gems] Account sync failed:', error);

          showToast('Saved on this device. Account sync will retry later.');

        }

      });

    return saveChains[kind];

  }

  async function syncFromAccount() {

    if (accountSyncPromise) return accountSyncPromise;

    accountSyncPromise = (async () => {

      try {

        const payload = await fetchAccountState();

        if (!payload?.ok || !payload.loggedIn) {

          accountState = 'logged-out';

          return payload;

        }

        accountState = 'logged-in';

        const customerId = String(payload.customerId || '');

        const storedCustomerId = readText(CUSTOMER_KEY);

        const localFavourites = normaliseList(read(FAVOURITES_KEY));

        const localCompare = normaliseList(read(COMPARE_KEY)).slice(0, MAX_COMPARE);

        const remoteFavourites = normaliseList(payload.favourites);

        const remoteCompare = normaliseList(payload.compare).slice(0, MAX_COMPARE);

        let nextFavourites;

        let nextCompare;

        let saveFavourites = false;

        let saveCompare = false;

        if (!storedCustomerId) {

          // First login on this browser: migrate the user's existing browser saves

          // into their Shopify customer account instead of discarding them.

          nextFavourites = mergeLists(remoteFavourites, localFavourites);

          nextCompare = mergeLists(remoteCompare, localCompare, MAX_COMPARE);

          saveFavourites = !sameHandles(nextFavourites, remoteFavourites);

          saveCompare = !sameHandles(nextCompare, remoteCompare);

        } else if (storedCustomerId !== customerId) {

          // A different customer has signed in on this browser.

          // Do not leak the previous customer's browser saves into this account.

          nextFavourites = remoteFavourites;

          nextCompare = remoteCompare;

          setDirty(FAVOURITES_DIRTY_KEY, false);

          setDirty(COMPARE_DIRTY_KEY, false);

        } else {

          // Once this browser is associated with the same customer, Shopify is

          // the source of truth unless a previous account save failed locally.

          if (isDirty(FAVOURITES_DIRTY_KEY)) {

            nextFavourites = localFavourites;

            saveFavourites = true;

          } else {

            nextFavourites = remoteFavourites;

          }

          if (isDirty(COMPARE_DIRTY_KEY)) {

            nextCompare = localCompare;

            saveCompare = true;

          } else {

            nextCompare = remoteCompare;

          }

        }

        write(FAVOURITES_KEY, nextFavourites);

        write(COMPARE_KEY, nextCompare);

        writeText(CUSTOMER_KEY, customerId);

        syncButtons(document);

        emitUpdate();

        if (saveFavourites) {

          try {

            const result = await postAccountList('favourites', nextFavourites);

            if (result?.ok) setDirty(FAVOURITES_DIRTY_KEY, false);

          } catch (error) {

            setDirty(FAVOURITES_DIRTY_KEY, true);

            console.warn('[RTG Saved Gems] Favourites migration failed:', error);

          }

        }

        if (saveCompare) {

          try {

            const result = await postAccountList('compare', nextCompare);

            if (result?.ok) setDirty(COMPARE_DIRTY_KEY, false);

          } catch (error) {

            setDirty(COMPARE_DIRTY_KEY, true);

            console.warn('[RTG Saved Gems] Compare migration failed:', error);

          }

        }

        return payload;

      } catch (error) {

        console.warn('[RTG Saved Gems] Unable to read customer account:', error);

        accountState = 'unknown';

        return null;

      } finally {

        accountSyncPromise = null;

      }

    })();

    return accountSyncPromise;

  }

  // Page-level removals must use the same account-sync path as toggle buttons.
  // This also raises the update event immediately for the current page/header.
  function removeSavedHandle(kind, handle) {
    const isFavourite = kind === 'favourites';
    const key = isFavourite ? FAVOURITES_KEY : COMPARE_KEY;
    const current = read(key);
    const next = current.filter(item => item && item.handle !== String(handle || ''));
    if (next.length === current.length) return false;

    write(key, next);
    syncButtons(document);
    emitUpdate();
    if (accountState !== 'logged-out') {
      queueAccountSave(kind, next);
    }
    return true;
  }

  function toggleFavourite(button) {

    const product = normaliseProduct(button);

    if (!product.handle) return;

    const list = read(FAVOURITES_KEY);

    const index = findIndex(list, product.handle);

    if (index === -1) {

      list.push(product);

      write(FAVOURITES_KEY, list);

      showToast('Added to favourites.');

    } else {

      list.splice(index, 1);

      write(FAVOURITES_KEY, list);

      showToast('Removed from favourites.');

    }

    syncButtons(document);

    emitUpdate();

    if (accountState !== 'logged-out') {

      queueAccountSave('favourites', read(FAVOURITES_KEY));

    }

  }

  function toggleCompare(button) {

    const product = normaliseProduct(button);

    if (!product.handle) return;

    const list = read(COMPARE_KEY);

    const index = findIndex(list, product.handle);

    if (index !== -1) {

      list.splice(index, 1);

      write(COMPARE_KEY, list);

      showToast(`Removed from compare. ${list.length}/${MAX_COMPARE} selected.`);

      syncButtons(document);

      emitUpdate();

      if (accountState !== 'logged-out') {

        queueAccountSave('compare', read(COMPARE_KEY));

      }

      return;

    }

    if (list.length >= MAX_COMPARE) {

      showToast(`Maximum of ${MAX_COMPARE} gemstones can be compared.`);

      return;

    }

    list.push(product);

    write(COMPARE_KEY, list);

    showToast(`Added to compare. ${list.length}/${MAX_COMPARE} selected.`);

    syncButtons(document);

    emitUpdate();

    if (accountState !== 'logged-out') {

      queueAccountSave('compare', read(COMPARE_KEY));

    }

  }

  document.addEventListener('click', event => {

    const favouriteButton = event.target.closest('[data-rtg-favourite]');

    if (favouriteButton) {

      event.preventDefault();

      event.stopPropagation();

      toggleFavourite(favouriteButton);

      return;

    }

    const compareButton = event.target.closest('[data-rtg-compare]');

    if (compareButton) {

      event.preventDefault();

      event.stopPropagation();

      toggleCompare(compareButton);

    }

  });

  document.addEventListener('DOMContentLoaded', () => {

    syncButtons(document);

    emitUpdate();

    syncFromAccount();

  });

  document.addEventListener('shopify:section:load', event => {

    syncButtons(event.target || document);

  });

  window.addEventListener('storage', event => {

    if (

      event.key === FAVOURITES_KEY ||

      event.key === COMPARE_KEY

    ) {

      syncButtons(document);

      emitUpdate();

    }

  });

  window.addEventListener('focus', () => {

    syncFromAccount();

  });

  window.RTGSavedGems = {

    __initialized: true,

    MAX_COMPARE,

    favouritesKey: FAVOURITES_KEY,

    compareKey: COMPARE_KEY,

    getFavourites: () => read(FAVOURITES_KEY),

    getCompare: () => read(COMPARE_KEY),
    removeFavourite: handle => removeSavedHandle('favourites', handle),
    removeCompare: handle => removeSavedHandle('compare', handle),

    syncButtons,

    syncHeaderCounts,

    syncFromAccount,

    showToast

  };

  // Covers cases where this asset loads after DOMContentLoaded.

  if (document.readyState !== 'loading') {

    syncButtons(document);

    emitUpdate();

    syncFromAccount();

  }

})();
